<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-content">

    <div class="cp-header">
      <div class="cp-label">
        {{ 'coupon_ok_title' | translate }}
      </div>
      <div class="cp-button" (click)="close()">
        <img src="assets/img/ic-close.png"/>
      </div>
    </div>

    <div class="content">
      <img class="cp-img" src="/assets/img/img-success.png">

      <div class="cp-title">
        {{'success_message' | translate }}
      </div>

      @if (!withAppSessionBlock) {
      <div class="cp-subtitle">
        {{'success_message_subtitle' | translate}}
        <span class="cp-bold">{{ email() }}</span>
        {{'success_message_subtitle2' | translate}} 
        {{ wonMonths }}
        {{'success_message_subtitle2_bis' | translate}} 
      </div>
      }

      @if (!withAppSessionBlock && (this.wonAnalysis || this.wonVideoTitles.length > 0)) {
      <p class="cp-subtitle">
        {{'success_activation_list_title' | translate}}
      </p>
      }

      @if (this.wonAnalysis || this.wonVideoTitles.length || (this.wonBrands.length && !withAppSessionBlock)) {
      <div class="cp-box">

        @if (this.wonAnalysis) {
        <div class="cp-box-row">
          <div class="cp-box-row-left">
            {{ 'product' | translate }}
          </div>
          <div class="cp-box-row-right">
            {{ 'success_activation_list_pedaling_analysis' | translate }}
          </div>
        </div>
        }

        @for (title of this.wonVideoTitles; track title) {
        <div class="cp-box-row">
          <div class="cp-box-row-left">
            {{ 'video' | translate }}
          </div>
          <div class="cp-box-row-right">
            {{ title }}
          </div>
        </div>
        }

        @if (!withAppSessionBlock) {
          @for (item of wonBrands; track item.id) {
            @if (item.imageUrl) {
            <div class="cp-box-row">
              <div class="cp-box-row-left">
                {{ 'coupon' | translate }}
              </div>
              <div class="cp-box-row-right">
                {{ item.name }} <img style="width:30px; height: 30px; margin: 2px;" src="{{ item.imageUrl }}" />
              </div>
            </div>
            }
          }
        }

      </div>
      }

      @if (!withAppSessionBlock && wonBrands.length > 0) {
      <div class="cp-subtitle">
        {{'success_message_subtitle4' | translate}} 
      </div>
      }

      @if (withAppSessionBlock) {
      <div class="cp-subtitle">
        <p>
          {{ 'success_message_activation_0' | translate }} 
          <a href="https://com-elite-myetraining-onepagesite.s3.eu-west-1.amazonaws.com/index.html" target="_blank">
          {{ 'success_message_activation_1' | translate }}
          </a>
        </p>
        <p>
          {{ 'success_message_activation_2' | translate }}
        </p>
        @if (this.wonBrands.length > 0) {
        <p>
          {{ 'success_message_activation_3' | translate }}
        </p>
        <p [innerHTML]="'success_message_subtitle3' | translate">
        </p>
        }
      </div>
      }

    </div>

    <div class="cp-footer">
      <button class="coupon-button gray" (click)="close()">
        {{ 'close' | translate | uppercase }}
      </button>
    </div>

  </div>
</div>
